import axios from "axios";
import { removeLoginCookie } from "components/LoginForm/LoginFormDao";
import { toastrError } from "lib/toastr";

const baseURL: any = process.env.REACT_APP_ENV ===`Production` ? "https://zampliasurveysbackend-development.azurewebsites.net" : "https://zampliasurveysbackend-sandbox.azurewebsites.net";
// let baseURL;
// switch (process.env.REACT_APP_ENV) {
//   case "production":
//     baseURL = process.env.REACT_APP_API_SERVER;
//     break;
//   case "development":
//     baseURL = process.env.REACT_APP_API_STAGING;
//     break;
//   case "test":
//     baseURL = process.env.REACT_APP_API_STAGING;
//     break;
//   case "staging":
//     baseURL = process.env.REACT_APP_API_STAGING;
//     break;
//   case "local":
//     baseURL = process.env.REACT_APP_API_SERVER_LOCAL;
//     break;
//   default:
//     baseURL = process.env.REACT_APP_API_STAGING || process.env.REACT_APP_API_SERVER_LOCAL;
//     break;
// }

export const axiosClient = axios.create({
  baseURL,
  withCredentials: true,
});

// Add JWT Token to Requests
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 Unauthorized Errors
let isSessionExpired = false;

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      if (!isSessionExpired) {
        isSessionExpired = true;
        toastrError("Session Expired");
        localStorage.removeItem("access_token");
        removeLoginCookie("setLoginCookie");
        localStorage.removeItem('bonusPopup');
        localStorage.removeItem('auth_ls');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);
